'use client';

import { useEffect } from 'react';

import {
  GTM_ACTION_FORM_SUBMISSION,
  GTM_EVENT_NAME_SUCCESSFUL_SIGNIN,
} from '@shared/utils/constants/gtm';
import { GTM_EVENT_SEND_SUCCESS_LOGIN_KEY } from '@shared/utils/constants/session-storage-keys';
import { sendGtmEvent } from '@shared/utils/helpers/send-gtm-event';

import { useUserContext } from '../providers/user-context';

export const GtmScript = () => {
  const { accessToken, personId, status } = useUserContext();

  useEffect(() => {
    if (accessToken && sessionStorage.getItem(GTM_EVENT_SEND_SUCCESS_LOGIN_KEY)) {
      sendGtmEvent({
        action: GTM_ACTION_FORM_SUBMISSION,
        eventName: GTM_EVENT_NAME_SUCCESSFUL_SIGNIN,
        label: GTM_EVENT_NAME_SUCCESSFUL_SIGNIN,
      });

      if (status !== 'loading') {
        sessionStorage.removeItem(GTM_EVENT_SEND_SUCCESS_LOGIN_KEY);
      }
    }
  }, [accessToken, personId, status]);

  return null;
};
